import {AxiosError} from 'axios';
import {POST_ANNOUNCEMENT_LISTING_URL} from '../../constants/apiUrls';
import axiosClient from '../axiosClient';
import {useCustomMutation} from '../utils/useCustomMutation';
import {Pageable, PageDataSort} from '../group-special-consideration/usePostGroupSCListing';
import {ApiPathParam} from '../../models/SearchParamSchema';
import {GenericErrorResponse} from "../typings";

// =============================================================================
// Request & Response Model
// =============================================================================
export interface AnnouncementListingRequest {
  announcementType: string;
  apiPathParam: ApiPathParam;
}

export interface AnnouncementListingResponseContentObject {
  uuid: string;
  title: string;
  startDate: string;
  endDate: string;
  updateDateTime: string;
  updatedBy: string;
  status: string;
  priority: boolean;
  creator: boolean;
}

export interface AnnouncementListingResponse {
  content: AnnouncementListingResponseContentObject[];
  pageable: Pageable;
  last: boolean;
  totalElements: number;
  totalPages: number;
  first: boolean;
  numberOfElements: number;
  size: number;
  number: number;
  sort: PageDataSort[];
  empty: boolean;
}

// =============================================================================
// Mutation
// =============================================================================
interface Input {
  onSuccess?: (data: AnnouncementListingResponse) => void;
  onError?: (data: AxiosError<GenericErrorResponse>) => void;
}

export const usePostAnnouncementListing = ({onSuccess, onError}: Input = {}) => {
  const postAnnouncementListing = async (requestData: AnnouncementListingRequest) => {
    const res = await axiosClient.post<AnnouncementListingResponse>(
        POST_ANNOUNCEMENT_LISTING_URL(requestData.apiPathParam),
        {
          announcementType: requestData.announcementType,
        }
    );
    return res.data;
  };

  return useCustomMutation(postAnnouncementListing, {
    onSuccess,
    onError,
  });
};
